import { useMutation } from "@tanstack/react-query";
import { createIdKortOrder } from "../../api/idkort";
import { CreateIdKortOrderModel } from "../../interfaces/idkort";

export const useCreateIdKortOrder = () =>
  useMutation({
    mutationFn: (model: CreateIdKortOrderModel) => createIdKortOrder(model),
  });
